import { Component, DestroyRef, ElementRef, OnDestroy, OnInit, ViewChild, HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import moment from 'moment';
import { AddProfileDialogComponent } from '@shared/components/add-profile-dialog/add-profile-dialog.component';
import { addVacationHrsuitePopupComponent } from '@shared/components/add-vacation-hrsuite/add-vacation-hrsuite-popup.component';
import { PopupExportStaffComponent } from '@shared/components/popup-export-staff/popup-export-staff.component';
import { RelaunchAvailabilityComponent } from '@shared/components/relaunch-availability/relaunch-availability.component';
import { ANESTHETIST, COMMISSION_REGULATION, NURSE, OPTIONS } from '@shared/const/globals.const';
import { AccessOptions } from '@shared/models/accessOptions.model';
import { Formation } from '@shared/models/formation.model';
import { Room } from '@shared/models/room.model';
import { HospitalNames } from '@shared/models/hospitalTypes.model';
import { Personas } from '@shared/models/personas.model';
import { Reason } from '@shared/models/reason.model';
import { ReasonMap } from '@shared/models/reasonMap.model';
import { User } from '@shared/models/user.model';
import { Profile } from '@shared/models/profile.model';
import { CalendarService } from '@shared/services/calendar.service';
import { deactivateComponentService } from '@shared/services/desactivate.service';
import { ErrorService } from '@shared/services/error.service';
import { ExportService } from '@shared/services/export.service';
import { HospitalService } from '@shared/services/hospital.service';
import { InstanceIdService } from '@shared/services/instance-id.service';
import { ReasonService } from '@shared/services/reason.service';
import { ReasonMapService } from '@shared/services/reasonMap.service';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import { UtilisService } from '@shared/services/utilis.service';
import { RoomService } from '@shared/services/room.service';
import posthog from 'posthog-js';
import { from, Observable, firstValueFrom } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserService } from 'src/app/shared/services/user.service';
import { NavigationService } from '../core/services/navigation.service';
import { StorageService } from '../core/services/storage.service';
import { HrsuiteService } from './hrsuite.service';
import { UserConfigurationService } from '@shared/services/userConfiguration.service';
import { ProfileService } from '@shared/services/profile.service';
import { PopulationDetailsPopupComponent } from '@shared/components/population-details-popup/population-details-popup.component';
import { FormationsGroups } from '@shared/models/formationsGroups.model';
import { formatDateAsISO } from '@shared/utils/cross-functions';
import { newUserConfiguration } from '@shared/interfaces/userConfiguration.interfaces';
import { UserConfiguration } from '@shared/models/userConfiguration.model';

@Component({
  selector: 'app-hrsuite',
  templateUrl: './hrsuite.component.html',
  styleUrls: ['./hrsuite.component.scss'],
  standalone: false,
})
export class HrsuiteComponent implements OnInit, OnDestroy {
  private instanceId: string;

  // we create an object that contains coordinates for the right click menu (on right click on doctor agenda)
  @ViewChild('moreActions', { static: false }) public moreActionsButton: ElementRef | undefined;

  public pages: any[] = [];

  public headerMode: string;

  public actifPage: string = 'Ibode / Ide / AS';

  public mainActifPage: string;

  public headerPages: string[] = [];

  public headerModeCampaign: string;

  public actifPageCampaign: string = 'Infirmières';

  public mainActifPageCampaign: string;

  public headerPagesCampaign: string[] = [];

  public headerPagesList: string[] = [];

  public headerPagesDemande: string[] = [];

  public actifPageList: string = 'Infirmières';

  public actifPageDemande: string = '';

  public profilesType: string | undefined;

  public currentRouteIsCommission: any;

  public isNight: boolean = false;

  public importButtonName: string = '';

  public isSurgeonOpeningsRooms: boolean = false;

  public isPerInterventionsPage: boolean = false;

  public isAnesthNeedsPage: boolean = false;

  public isVacationPagebool: boolean = false;

  public isAnesthResponsibleRoomDetails: boolean = false;

  public doesHospitalHaveCalendarsDataPipelineOption: boolean;

  public canDataBeRequestByUsers: boolean;

  public isChangeAnesthNeeds: boolean = false;

  public toggledEvents: boolean = false;

  public isChirPage: boolean = false;

  public reasonsMaps: ReasonMap[] = [];

  public reasons: Reason[] = [];

  public allReasons: Reason[] = [];

  public accessOptions: AccessOptions | undefined;

  // All the formations that the user's allowed to access
  public allFormations: Formation[] | undefined;

  // All the formations groups that the user's allowed to access
  public allFormationsGroups: FormationsGroups[] | undefined;

  // All the rooms of the hospital
  public allRooms: Room[] | undefined;

  // All the profiles of the selected perimeter (for the details)
  public populationProfiles: Profile[] | undefined;

  // All the rooms of the selected perimeter (for the details)
  public populationRooms: Room[] | undefined;

  // All the formations of the selected perimeter (for the details)
  public populationFormations: Formation[] | undefined;

  // Signal to control the state of the button "Charger les données"
  public hasChanges: boolean = false;

  public hospitalNames: HospitalNames;

  public isBasicService: boolean;

  public exportPlanningInProgress: boolean = false;

  public populationList: any[] = [];

  public isLoadingPopulation: boolean = true;

  // Form control to stock the value of the selected perimeter
  public currentPopulation: FormControl = new FormControl();

  // Form control to stock the value of the selected formations group
  public currentFormationGroup: FormControl = new FormControl();

  // The selected perimeter's or formations group's name to display in the selector
  public selectionName: string = '';

  public isPopulationDropdownOpen: boolean = false;

  public get isThereNewModifs(): boolean {
    return false;
  }

  public get isDarkMode() {
    return this.router.url.includes('hrsuite/besoinsgarde');
  }

  public get isCampaignPage() {
    return this.router.url.includes('/hrsuite/campaigns');
  }

  public get isScenarioPage() {
    return this.router.url.includes('scenario') && this.router.url.includes('campaign');
  }

  public get isListPage() {
    return this.router.url.includes('liste');
  }

  public get isDemandePage() {
    return this.router.url.includes('demande-rh');
  }

  public isMultiHospitals: boolean = false;

  // Stats RH Date Properties
  public today = moment().startOf('day').utc().toDate();

  public options = [
    { label: 'Stratégique', value: true },
    { label: 'Opérationnel', value: false },
  ];

  public strategic: boolean = true;

  public configDropdownOpen: boolean = false;

  // the start date in the date range picker
  public startDay: moment.Moment | string | Date | undefined;

  // the end date in the date range picker
  public endDay: moment.Moment | string | Date | undefined;

  // the parameters of the last data loaded
  public loadedState: {
    lastPopulationId: string;
    lastStartDay: string;
    lastEndDay: string;
    displayInHourVolume?: boolean;
    considerBreaktimes?: boolean;
    includeWeekends?: boolean;
  } = {
    lastPopulationId: '',
    lastStartDay: '',
    lastEndDay: '',
  };

  public displayInHourVolume?: boolean;

  public considerBreaktimes?: boolean;

  public includeWeekends?: boolean;

  public statsRHLoading$: Observable<boolean>;

  constructor(
    private readonly storageService: StorageService,
    private readonly userService: UserService,
    private readonly userConfigurationService: UserConfigurationService,
    private readonly navigationServ: NavigationService,
    private readonly utilisService: UtilisService,
    private readonly deactivateService: deactivateComponentService,
    private readonly router: Router,
    private readonly dialog: MatDialog,
    private readonly hrsuiteService: HrsuiteService,
    private readonly hospitalService: HospitalService,
    private readonly errorService: ErrorService,
    private readonly reasonMapService: ReasonMapService,
    private readonly reasonService: ReasonService,
    private destroyRef: DestroyRef,
    private subscriptionManager: SubscriptionManager,
    private instanceIdService: InstanceIdService,
    private exportService: ExportService,
    private calendarService: CalendarService,
    private readonly roomService: RoomService,
    private readonly profileService: ProfileService
  ) {
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);
    this.accessOptions = this.userService.getAccessOptionsOfPage(this.router.url.replace('/history', ''));
    this.hospitalNames = this.userService.getHospitalNames();
    this.isBasicService = this.userService.isBasicService();
    this.headerMode = this.accessOptions?.pageTitle ?? '';
    this.mainActifPage = this.accessOptions?.pageTitle ?? '';
    this.headerModeCampaign = this.accessOptions?.pageTitle ?? '';
    this.mainActifPageCampaign = this.accessOptions?.pageTitle ?? '';
    this.doesHospitalHaveCalendarsDataPipelineOption =
      this.hospitalService.doesHospitalHaveCalendarsDataPipelineOption();
    this.canDataBeRequestByUsers = this.hospitalService.doesHospitalHaveCalendarsDataPipelineButton();

    this.subscriptionManager.createRequest(this.router.events, 'routerEvents', this.instanceId).subscribe({
      next: (event: any) => {
        if (event instanceof NavigationEnd) {
          this.currentRouteIsCommission = event.url.includes(COMMISSION_REGULATION);
          this.isVacationPagebool = this.router.url.endsWith('par-salles');
          this.isAnesthNeedsPage =
            this.router.url.includes('besoinsgarde') || this.router.url.includes('simpledayneeds');
        }
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });

    this.pages = [];
    this.headerPages = [];
    this.headerPagesCampaign = [];
    this.headerPagesList = [];
    this.headerPagesDemande = [];

    this.initImportButtonName();
    this.onHeaderModeChange();
    this.isSurgeonOpeningsRoomsSubjectListener();
    this.isAnesthNeedsSubjectListener();
    this.isAnesthResponsibleRoomDetailsSubjectListener();
    this.isChangeSurgeonRoomsListener();
    this.isChangeAnesthNeedsListener();
    this.isPerInterventionsPageSubjectListener();
    this.getReasonsMaps();
    this.getReasons();

    this.statsRHLoading$ = this.hrsuiteService.statsRHLoading$;
  }

  ngOnInit(): void {
    this.setAuthorizedPages();
    this.setRelatedLinksActifToPages();
    this.subscribeToRouteChange();
    this.isMultiHospitals = this.userService.isCurrentUserHasMultipleHospitalsSelected();

    if (this.accessOptions?.pageUrl?.includes('hrsuite/stats-rh')) {
      this.getAllFormations();
      this.getAllRooms();

      const selectedHospitals = this.userService.getSelectedHospitals();
      const mostRecentCachedData = this.hrsuiteService.getMostRecentForHospitals(selectedHospitals?.join(','));

      if (mostRecentCachedData) {
        this.loadedState.lastPopulationId = mostRecentCachedData.populationId;
        this.loadedState.lastStartDay = mostRecentCachedData.fromDate;
        this.loadedState.lastEndDay = mostRecentCachedData.toDate;
      }

      this.initPopulation(mostRecentCachedData?.populationId, mostRecentCachedData?.isFormationGroup); // <-- The initialization of some user config parameters take place here

      let startDate, endDate;

      if (!mostRecentCachedData) {
        const previousMonth = moment().subtract(1, 'month');

        startDate = previousMonth.startOf('month').toDate();
        endDate = previousMonth.endOf('month').toDate();
      } else {
        const startDateStr = mostRecentCachedData.fromDate,
          endDateStr = mostRecentCachedData.toDate;
        const [s_year, s_month, s_day] = startDateStr.split('-').map(Number);
        const [e_year, e_month, e_day] = endDateStr.split('-').map(Number);

        startDate = new Date(s_year, s_month - 1, s_day);
        endDate = new Date(e_year, e_month - 1, e_day);
      }

      this.onStatsRhDateChange({ startDate, endDate });
    }

    this.subscriptionManager
      .createRequest(this.hrsuiteService.toggleNightSubject, 'toggleNightSubject', this.instanceId)
      .subscribe({
        next: (val: any) => {
          this.isNight = val;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
    this.hrsuiteService.darkModeSubject.next(this.isDarkMode);
  }

  /**
   * Check if the current state differs from the loaded state
   * Returns true if any population ID or date has changed
   */
  private isStateChanged(
    currentPopulationId: string,
    currentStartDay: string,
    currentEndDay: string,
    displayInHourVolume?: boolean,
    includeWeekends?: boolean,
    considerBreaktimes?: boolean
  ): boolean {
    return (
      currentPopulationId !== this.loadedState.lastPopulationId ||
      currentStartDay !== this.loadedState.lastStartDay ||
      currentEndDay !== this.loadedState.lastEndDay ||
      displayInHourVolume !== this.loadedState.displayInHourVolume ||
      includeWeekends !== this.loadedState.includeWeekends ||
      considerBreaktimes !== this.loadedState.considerBreaktimes
    );
  }

  /**
   * Get user's population(s), a population being a set of formations
   * Small disclaimer, we'll sometimes use .*formations or .*positions.
   * 'formations' and 'positions' are used interchangeably as they mean the same thing
   */
  initPopulation(populationId?: string, isFormationGroup?: boolean): void {
    this.isLoadingPopulation = true;

    this.subscriptionManager
      .createRequest(from(this.userService.getAllFormationsGroups()), 'getAllFormationsGroups', this.instanceId)
      .subscribe({
        next: async (res: FormationsGroups[]) => {
          this.allFormationsGroups = res.filter(
            (fg: FormationsGroups) =>
              this.accessOptions?.positions?.includes(String(fg._id)) && (fg.hasSkills || fg.isUsingAnesthNeeds)
          );

          this.subscriptionManager
            .createRequest(
              this.userConfigurationService.getUserConfigurations(),
              'getUserConfigurations',
              this.instanceId
            )
            .subscribe({
              next: async (userConfiguration: any) => {
                this.hrsuiteService.statsRHUserConfigSubject.next(userConfiguration);
                const statsRHConfig = userConfiguration.statsRH;

                this.includeWeekends = statsRHConfig.includeWeekends;
                this.displayInHourVolume = statsRHConfig.displayInHourVolume;
                this.considerBreaktimes = statsRHConfig.considerBreaktimes;

                this.loadedState.displayInHourVolume = this.displayInHourVolume;
                this.loadedState.includeWeekends = this.includeWeekends;
                this.loadedState.considerBreaktimes = this.considerBreaktimes;

                if (!this.isMultiHospitals) {
                  this.populationList = userConfiguration.population
                    ? userConfiguration.population.sort((a: any, b: any) => a.priority - b.priority)
                    : [];

                  // Create a map of FormationGroup to its formations
                  const formationGroupFormationsMap = new Map<string, Formation[]>();
                  for (const fg of this.allFormationsGroups ?? []) {
                    const formations = await this.userService.getFormationsOfFormationsGroup(fg, true);
                    if (fg._id) {
                      formationGroupFormationsMap.set(fg._id.toString(), formations);
                    }
                  }

                  // Attach typeMode to each population by finding matching FormationGroup
                  for (const population of this.populationList) {
                    if (population.formations && population.formations.length > 0) {
                      const populationFormationIds = new Set<string>(
                        population.formations.map((f: any) => (typeof f === 'string' ? f : f.toString()))
                      );

                      for (const [fgId, formations] of formationGroupFormationsMap) {
                        const fgFormationIds = new Set(formations.map((f: Formation) => f._id?.toString() || ''));

                        // Check if formations match (same size and all IDs present)
                        if (Array.from(populationFormationIds).every((id: string) => fgFormationIds.has(id))) {
                          const formationGroup = this.allFormationsGroups?.find((fg) => fg._id?.toString() === fgId);
                          if (formationGroup) {
                            population.typeMode = formationGroup.typeMode;
                          }
                          break;
                        }
                      }
                    }
                  }
                }

                if (populationId) {
                  if (isFormationGroup || this.isMultiHospitals) {
                    if (this.allFormationsGroups && this.allFormationsGroups.length > 0) {
                      const fg = this.allFormationsGroups?.find((fg) => fg._id === populationId);
                      await this.onPopulationSelected(fg || this.allFormationsGroups[0], true);
                    }
                  } else {
                    if (this.populationList && this.populationList.length > 0) {
                      const pop = this.populationList.find((pop) => pop._id === populationId);
                      await this.onPopulationSelected(pop || this.populationList[0], false);
                    }
                  }
                } else {
                  if (this.allFormationsGroups && this.allFormationsGroups.length > 0) {
                    await this.onPopulationSelected(this.allFormationsGroups[0], true);
                  }
                }

                this.isLoadingPopulation = false;
              },

              error: (error: any) => {
                this.errorService.handleError(error);
                this.isLoadingPopulation = false;
              },
            });
        },
        error: (error: any) => {
          this.errorService.handleError(error);
          this.isLoadingPopulation = false;
        },
      });
  }

  modifyUserStatsRHConfig(param: string) {
    if (!['displayInHourVolume', 'considerBreaktimes', 'includeWeekends'].includes(param)) {
      return;
    }

    const newUserConfiguration: newUserConfiguration = { statsRH: {} };

    if (param === 'displayInHourVolume') {
      this.displayInHourVolume = !this.displayInHourVolume;
      newUserConfiguration.statsRH!.displayInHourVolume = this.displayInHourVolume;
    }

    if (param === 'includeWeekends') {
      this.includeWeekends = !this.includeWeekends;
      newUserConfiguration.statsRH!.includeWeekends = this.includeWeekends;
    }

    if (param === 'considerBreaktimes') {
      this.considerBreaktimes = !this.considerBreaktimes;
      newUserConfiguration.statsRH!.considerBreaktimes = this.considerBreaktimes;
    }

    const newStart = formatDateAsISO(this.startDay as Date);
    const newEnd = formatDateAsISO(this.endDay as Date);
    const currentPopulationId = this.currentPopulation.value?._id || this.currentFormationGroup.value?._id || '';

    this.hasChanges = this.isStateChanged(
      currentPopulationId,
      newStart,
      newEnd,
      this.displayInHourVolume,
      this.includeWeekends,
      this.considerBreaktimes
    );

    this.hrsuiteService.changeSateSubject.next(this.hasChanges);

    this.subscriptionManager
      .createRequest(
        this.userConfigurationService.modifyUserConfigurations(newUserConfiguration),
        'modifyUserConfigurations',
        this.instanceId
      )
      .subscribe({
        next: (userConfiguration: UserConfiguration) => {
          this.hrsuiteService.statsRHUserConfigSubject.next(userConfiguration);
          this.hrsuiteService.clearCache();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  @HostListener('window: click', ['$event'])
  click(_event: any) {
    if (this.isPopulationDropdownOpen) {
      this.isPopulationDropdownOpen = false;
    }

    if (this.configDropdownOpen) {
      this.configDropdownOpen = false;
    }
  }

  async getAllFormations() {
    const profilesType = this.accessOptions?.positions ?? []; // <- formations groups ids
    this.allFormations = await this.userService.getAccessOptionsPositionsByPositions(profilesType, true); // <- formations from formations
  }

  getAllRooms() {
    this.subscriptionManager.createRequest(this.roomService.getAllRooms(), 'getAllRooms', this.instanceId).subscribe({
      next: (res: Room[]) => {
        this.allRooms = res;
      },
      error: (error: any) => this.errorService.handleError(error),
    });
  }

  async onPopulationSelected(selection: FormationsGroups | any, isFormationGroup: boolean = false) {
    const newStart = formatDateAsISO(this.startDay as Date);
    const newEnd = formatDateAsISO(this.endDay as Date);
    const currentPopulationId = selection._id || '';

    this.hasChanges = this.isStateChanged(
      currentPopulationId,
      newStart,
      newEnd,
      this.displayInHourVolume,
      this.includeWeekends,
      this.considerBreaktimes
    );
    this.hrsuiteService.changeSateSubject.next(this.hasChanges);

    if (!isFormationGroup) {
      this.currentFormationGroup.setValue(undefined);
      this.currentPopulation.setValue(selection);

      this.populationRooms =
        !selection?.roomsPerimeter || selection.roomsPerimeter.length === 0
          ? [...(this.allRooms || [])]
          : selection.roomsPerimeter.map((rid: string) => this.allRooms?.find((r: Formation) => r._id === rid));

      this.populationFormations =
        !selection?.formations || selection.formations.length === 0
          ? [...(this.allFormations || [])]
          : selection.formations.map((fid: string) => this.allFormations?.find((f: Formation) => f._id === fid));

      const res = await this.getPopulationProfiles();
      this.populationProfiles = res.docs;

      this.selectionName = selection?.name;

      this.hrsuiteService.selectedPopulationSubject.next(selection !== null ? selection : undefined);
    } else {
      this.currentPopulation.setValue(undefined);
      this.currentFormationGroup.setValue(selection);

      this.selectionName = selection?.displayName || selection?.name;

      this.hrsuiteService.selectedFormationGroupSubject.next(selection !== null ? selection : undefined);
    }
  }

  async getPopulationProfiles() {
    const selectedPopulation = this.currentPopulation.value;

    let services = 'all';
    if (selectedPopulation) {
      services = selectedPopulation?.services ?? 'all';
    }

    let profilesIds = undefined,
      residency = this.accessOptions?.residency?.length === 1 ? this.accessOptions?.residency[0] : undefined;

    if (selectedPopulation && selectedPopulation.profilesIds && selectedPopulation.profilesIds.length > 0) {
      profilesIds = JSON.stringify(selectedPopulation.profilesIds);
    }

    if (selectedPopulation && selectedPopulation.residency && selectedPopulation.residency.length === 1) {
      residency = selectedPopulation.residency[0];
    }

    const formations =
      (selectedPopulation?.formations?.length ?? 0) > 0
        ? JSON.stringify(selectedPopulation.formations)
        : JSON.stringify(this.allFormations?.map((formation: Formation) => formation._id));

    return firstValueFrom(
      this.subscriptionManager.createRequest(
        this.profileService.getProfilesByPosition(
          'All',
          null,
          null,
          '',
          false,
          false,
          undefined,
          this.accessOptions?.seniority ? this.accessOptions.seniority.join(', ') : undefined,
          false,
          undefined,
          undefined,
          0,
          formations,
          profilesIds,
          residency,
          { noHospitalsLookup: true },
          undefined,
          services,
          true
        ),
        'getProfilesByPosition',
        this.instanceId,
        false,
        200
      )
    );
  }

  togglePopulationDropdown() {
    this.isPopulationDropdownOpen = !this.isPopulationDropdownOpen;

    if (this.isPopulationDropdownOpen) {
      this.configDropdownOpen = false;
    }
  }

  openPopulationDetailPopup(): void {
    this.isPopulationDropdownOpen = false;
    this.configDropdownOpen = false;

    if (this.isLoadingPopulation || !this.currentPopulation.value) {
      return;
    }

    this.subscriptionManager.createRequest(
      this.dialog
        .open(PopulationDetailsPopupComponent, {
          width: '960px',
          height: '720px',
          panelClass: 'population-details-popup-container',
          data: {
            selectedPopulation: this.currentPopulation.value,
            populationProfiles: this.populationProfiles,
            populationFormations: this.populationFormations,
            populationRooms: this.populationRooms,
            hospitalNames: this.hospitalNames,
          },
        })
        .afterClosed(),
      'PopulationDetailsPopupComponent',
      this.instanceId
    );
  }

  openConfigDropdown() {
    this.configDropdownOpen = !this.configDropdownOpen;
    if (this.configDropdownOpen) {
      this.isPopulationDropdownOpen = false;
    }
  }

  changeRHStatsMode() {
    this.strategic = !this.strategic;
    this.hrsuiteService.strategicModeSubject.next(this.strategic);
  }

  loadData() {
    // Disable the button
    this.hasChanges = false;
    this.configDropdownOpen = false;
    this.isPopulationDropdownOpen = false;
    this.hrsuiteService.changeSateSubject.next(this.hasChanges);

    const currentPopulationId = this.currentPopulation.value?._id || this.currentFormationGroup.value?._id || '';
    const currentStartDay = formatDateAsISO(this.startDay as Date);
    const currentEndDay = formatDateAsISO(this.endDay as Date);

    this.loadedState = {
      lastPopulationId: currentPopulationId,
      lastStartDay: currentStartDay,
      lastEndDay: currentEndDay,
      displayInHourVolume: this.displayInHourVolume,
      includeWeekends: this.includeWeekends,
      considerBreaktimes: this.considerBreaktimes,
    };

    this.hrsuiteService.loadStatsRhDataSubject.next(true);
  }

  onStatsRhDateChange(data: { startDate: Date; endDate: Date }): void {
    const startLocal = moment.utc(data.startDate).local();
    const endLocal = moment.utc(data.endDate).local();

    this.startDay = startLocal.toDate();
    this.endDay = endLocal.toDate();

    const newStart = formatDateAsISO(data.startDate);
    const newEnd = formatDateAsISO(data.endDate);
    const currentPopulationId = this.currentPopulation.value?._id || this.currentFormationGroup.value?._id || '';

    this.hasChanges = this.isStateChanged(
      currentPopulationId,
      newStart,
      newEnd,
      this.displayInHourVolume,
      this.includeWeekends,
      this.considerBreaktimes
    );
    this.hrsuiteService.changeSateSubject.next(this.hasChanges);

    this.hrsuiteService.requestDatesSubject.next({
      startDate: startLocal.toDate(),
      endDate: endLocal.toDate(),
    });
  }

  public get isClosingRoom() {
    return this.hrsuiteService.isClosingRoom;
  }

  public get isSavingSurgeonOpenings() {
    return this.hrsuiteService.isSavingSurgeonOpenings;
  }

  public get isSavingAnesthNeeds() {
    return this.hrsuiteService.isSavingAnesthNeeds;
  }

  public get isSurgeonPage() {
    return this.actifPage === 'Chirurgiens';
  }

  initImportButtonName(): void {
    const hospital = this.userService
      .getCurrentUser()
      ?.profile?.hospitals?.find((hospital: any) => hospital._id === this.userService.getUserPrincipalHospitalId());
    const CalendarsDataPipelineOption = hospital?.options.find((e: any) => {
      return e.name === OPTIONS.CALENDARS_DATA_PIPELINE;
    });

    const softwareName =
      CalendarsDataPipelineOption && CalendarsDataPipelineOption.softwareName
        ? CalendarsDataPipelineOption.softwareName
        : '';
    this.importButtonName = `Actualiser depuis ${softwareName}`;
  }

  isSurgeonOpeningsRoomsSubjectListener() {
    this.subscriptionManager
      .createRequest(
        this.hrsuiteService.isSurgeonOpeningsRoomsSubject,
        'isSurgeonOpeningsRoomsSubject',
        this.instanceId
      )
      .subscribe({
        next: (result: any) => {
          this.isSurgeonOpeningsRooms = result;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  isAnesthNeedsSubjectListener() {
    this.subscriptionManager
      .createRequest(this.hrsuiteService.isAnesthNeedsPageSubject, 'isAnesthNeedsPageSubject', this.instanceId)
      .subscribe({
        next: (result: any) => {
          this.isAnesthNeedsPage = result;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  isAnesthResponsibleRoomDetailsSubjectListener() {
    this.subscriptionManager
      .createRequest(
        this.hrsuiteService.isAnesthResponsibleRoomDetailsSubject,
        'isAnesthResponsibleRoomDetailsSubject',
        this.instanceId
      )
      .subscribe({
        next: (result: any) => {
          this.isAnesthResponsibleRoomDetails = result;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  isPerInterventionsPageSubjectListener() {
    this.subscriptionManager
      .createRequest(
        this.hrsuiteService.isPerInterventionsPageSubject,
        'isPerInterventionsPageSubject',
        this.instanceId
      )
      .subscribe({
        next: (result: any) => {
          this.isPerInterventionsPage = result;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  setAuthorizedPages() {
    const currentUser: User = this.storageService.getUser();
    if (this.accessOptions && currentUser && currentUser.persona) {
      this.pages =
        ((currentUser.persona as Personas)?.accessOptions as AccessOptions[])
          ?.filter(
            (accessOption: AccessOptions) =>
              accessOption.pageTitle === this.accessOptions!.pageTitle &&
              accessOption.headerTitle &&
              accessOption.pageUrl &&
              accessOption.multipleHeader &&
              accessOption.displayInHeader
          )
          .sort((a: AccessOptions, b: AccessOptions) => {
            return (a?.headerPriority ?? 99) - (b?.headerPriority ?? 99);
          })
          .map((accessOption: AccessOptions) => {
            return {
              label: accessOption.headerTitle,
              link: accessOption.pageUrl,
            };
          }) ?? [];

      this.headerPages = this.pages.map((p: any) => p.label);
      this.headerPagesCampaign =
        ((currentUser.persona as Personas)?.accessOptions as AccessOptions[])
          ?.filter(
            (accessOption: AccessOptions) => accessOption.pageUrl === '/hrsuite/campaigns' && accessOption.headerTitle
          )
          .sort((a: AccessOptions, b: AccessOptions) => {
            return (a?.headerPriority ?? 99) - (b?.headerPriority ?? 99);
          })
          .map((accessOption: AccessOptions) => accessOption.headerTitle!) ?? [];
      this.actifPageCampaign = this.headerPagesCampaign[0];
      this.headerPagesList =
        ((currentUser.persona as Personas)?.accessOptions as AccessOptions[])
          ?.filter(
            (accessOption: AccessOptions) => accessOption.pageUrl === '/hrsuite/liste' && accessOption.headerTitle
          )
          .sort((a: AccessOptions, b: AccessOptions) => {
            return (a?.headerPriority ?? 99) - (b?.headerPriority ?? 99);
          })
          .map((accessOption: AccessOptions) => accessOption.headerTitle!) ?? [];
      this.actifPageList = this.headerPagesList[0];
      this.headerPagesDemande =
        ((currentUser.persona as Personas)?.accessOptions as AccessOptions[])
          ?.filter(
            (accessOption: AccessOptions) =>
              accessOption.pageUrl?.includes('/hrsuite/demande-rh') && !accessOption.parentId
          )
          .sort((a: AccessOptions, b: AccessOptions) => {
            return (a?.headerPriority ?? 99) - (b?.headerPriority ?? 99);
          })
          .map((accessOption: AccessOptions) => accessOption.headerTitle!) ?? [];

      if (history.state.position) {
        this.actifPageDemande = history.state.position;
        this.hrsuiteService.demandePositions.next(history.state.position);
      } else {
        const currentValue = this.hrsuiteService.demandePositions.getValue();

        if (!currentValue) {
          this.actifPageDemande = this.headerPagesDemande[0];
          this.hrsuiteService.demandePositions.next(this.actifPageDemande);
        } else {
          this.actifPageDemande = currentValue;
        }
      }
    }
  }

  subscribeToRouteChange() {
    this.subscriptionManager
      .createRequest(this.router.events, 'subscribeToRouteChange', this.instanceId)
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe({
        next: (_event: NavigationEnd) => {
          this.setRelatedLinksActifToPages();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  onHeaderModeChange() {
    this.subscriptionManager
      .createRequest(this.router.events, 'onHeaderModeChange', this.instanceId)
      .pipe(filter((event: any) => event instanceof NavigationEnd || event instanceof Router))
      .subscribe({
        next: (navigationEnd: any) => {
          this.headerMode = this.accessOptions?.pageTitle ?? '';
          if (navigationEnd.url.includes('/campaigns')) {
            if (
              this.router.getCurrentNavigation() &&
              this.router.getCurrentNavigation()?.extras &&
              this.router.getCurrentNavigation()?.extras?.state
            ) {
              if (this.router?.getCurrentNavigation()?.extras?.state?.['position']) {
                this.actifPageCampaign = this.router.getCurrentNavigation()?.extras?.state?.['position'];
              }
            }
          }
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  setRelatedLinksActifToPages() {
    if (this.accessOptions?.headerTitle) {
      this.actifPage = this.accessOptions.headerTitle;

      if (this.accessOptions?.pageUrl?.includes('Infirmiere')) {
        this.profilesType = NURSE;
      } else if (this.accessOptions?.pageUrl?.includes('Anesthesiste')) {
        this.profilesType = ANESTHETIST;
      }
    }
  }

  navigateTo(link: any): Promise<boolean> {
    return new Promise((resolve: any) => {
      this.subscriptionManager.createRequest(this.goToNextEvent(), 'goToNextEvent', this.instanceId).subscribe({
        next: (res: any) => {
          if (res && res !== 'cancel') {
            this.isNight = false;
            this.navigationServ
              .navigateTo(link.link, null, false)
              .then(() => {
                resolve(true);
              })
              .catch(() => {
                resolve(false);
              });
          } else if (res === false) {
            this.save();
            resolve(false);
          } else {
            resolve(false);
          }
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
    });
  }

  isChangeSurgeonRoomsListener() {
    this.subscriptionManager
      .createRequest(this.hrsuiteService.isChangeSurgeonRoomsSubject, 'isChangeSurgeonRoomsSubject', this.instanceId)
      .subscribe({
        next: (isChange: any) => {
          this.hrsuiteService.isChangeSurgeonRooms = isChange;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  isChangeAnesthNeedsListener() {
    this.subscriptionManager
      .createRequest(this.hrsuiteService.isChangeAnesthNeedsSubject, 'isChangeAnesthNeedsSubject', this.instanceId)
      .subscribe({
        next: (isChange: any) => {
          this.isChangeAnesthNeeds = isChange;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  async onClickHandlerAnesth(onClickEventName: string): Promise<void> {
    switch (onClickEventName) {
      case 'discard':
        this.refreshAnesthNeeds();
        break;
      case 'save':
        this.saveAnesthNeeds();
        break;
    }
  }

  updateAccessOptions(page: string) {
    this.accessOptions = this.userService.getAccessOptionsOfPage(this.router.url, {
      keyName: 'headerTitle',
      checkWith: page,
    });
  }

  async getFormationsNames(): Promise<(string | undefined)[]> {
    return (await this.userService.getAccessOptionsPositionsByPositions(this.accessOptions?.positions)).map(
      (formation: Formation) => formation.name
    );
  }

  async navigateToPage(page: any) {
    if (
      page === this.actifPage &&
      !this.router.url.includes('campaigns') &&
      !this.router.url.includes('liste') &&
      !this.router.url.includes('demande-rh')
    ) {
      return;
    }

    const previousPage = this.actifPage;

    if (this.router.url.includes('campaigns')) {
      posthog.capture('Switch_Formation_Group', { page_source: 'HR_Requests_Campaigns' });
      this.actifPageCampaign = page;
      this.changeCampaignPos();
      return;
    }

    if (this.router.url.includes('liste')) {
      posthog.capture('Switch_Formation_Group', { page_source: 'Profile_List' });
      this.actifPageList = page;
      this.changeListePos();
      return;
    }

    if (this.router.url.includes('demande-rh')) {
      posthog.capture('Switch_Formation_Group', { page_source: 'HR_Requests' });
      this.actifPageDemande = page;
      this.updateAccessOptions(page);
      this.changeDemandePos();
      this.hrsuiteService.updateNumberOfCR((await this.getFormationsNames()) as string[]);
      return;
    }

    const navigateToPage = this.pages.find((p: any) => p.label === page);

    if (navigateToPage) {
      this.hrsuiteService.toggleNightSubject.next(false);
      this.navigateTo(navigateToPage)
        .then((success: any) => {
          if (success) {
            this.actifPage = navigateToPage.label;
          } else {
            this.actifPage = previousPage;
          }
        })
        .catch(() => {
          this.actifPage = previousPage;
        });
    }
  }

  save() {
    this.deactivateService.switchDeactivate.next(true);
  }

  goToNextEvent() {
    if (this.isThereNewModifs) {
      return this.utilisService.openUnSavedChangesPopup();
    } else {
      return new Observable((sub: any) => sub.next(true));
    }
  }

  addProfileClick(): void {
    posthog.capture('Open_Add_Profile_Form', { page_source: 'Profile_List' });
    this.subscriptionManager
      .createRequest(
        this.dialog
          .open(AddProfileDialogComponent, {
            data: {
              type: this.accessOptions?.isAnesthMode ? ANESTHETIST : NURSE,
              openType: 'ADD',
              topAccessOptions: this.userService.getAccessOptionsOfPage(this.router.url, {
                keyName: 'headerTitle',
                checkWith: this.actifPageList,
              }),
            },
          })
          .afterClosed(),
        'AddProfileDialogComponent',
        this.instanceId
      )
      .subscribe({
        next: (result: any) => {
          if (result) {
            this.hrsuiteService.profilesUpdateSubject.next(this.profilesType);
          }
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  async openVacationPopup() {
    posthog.capture('Open_Add_Vacation/Mission_Form', { page_source: 'Profile_List' });
    const topAccessOptions = this.userService.getAccessOptionsOfPage(this.router.url, {
      keyName: 'headerTitle',
      checkWith: this.actifPageList,
    });
    const position = await this.userService.getAccessOptionsPositionsByPositions(
      topAccessOptions?.positionsInPopUp ?? [],
      true
    );

    this.subscriptionManager
      .createRequest(
        this.dialog
          .open(addVacationHrsuitePopupComponent, {
            minWidth: '504px',
            maxWidth: '1120px',
            data: {
              position,
              reasonsMaps: this.reasonsMaps,
              reasons: this.allReasons,
              topAccessOptions,
            },
          })
          .afterClosed(),
        'addVacationHrsuitePopupComponent',
        this.instanceId
      )
      .subscribe({
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  async openPopupRelaunchAvai() {
    posthog.capture('Open_Relaunch_Availability_Form', { page_source: 'Profile_List' });
    const topAccessOptions = this.userService.getAccessOptionsOfPage(this.router.url, {
      keyName: 'headerTitle',
      checkWith: this.actifPageList,
    });
    this.utilisService.openPopup(RelaunchAvailabilityComponent, {
      width: '520px',
      data: {
        position: await this.userService.getAccessOptionsPositionsByPositions(
          topAccessOptions?.positionsInPopUp ?? [],
          true
        ),
        topAccessOptions,
      },
    });
  }

  async openExportDialog() {
    const dialogRef = this.dialog.open(PopupExportStaffComponent, {
      width: '496px',
      data: {
        startDate: new Date(),
        endDate: new Date(),
      },
    });
    const topAccessOptions = this.userService.getAccessOptionsOfPage(this.router.url, {
      keyName: 'headerTitle',
      checkWith: this.actifPageList,
    });
    const position =
      (await this.userService.getAccessOptionsPositionsByPositions(topAccessOptions?.positions ?? [], true)).map(
        (formation: Formation) => formation.name ?? ''
      ) ?? [];
    this.subscriptionManager.createRequest(dialogRef.afterClosed(), 'openExportDialog', this.instanceId).subscribe({
      next: (result: { startDate: string; endDate: string } | undefined) => {
        if (!result) {
          return;
        }

        const startDate = new Date(result.startDate);
        startDate.setUTCHours(0, 0, 0, 0);

        const endDate = new Date(result.endDate);
        endDate.setUTCHours(0, 0, 0, 0);

        const hospitalId = this.userService.getUserPrincipalHospitalId();
        if (!hospitalId) {
          return;
        }

        const populationId = this.exportService.getPopulationId();

        this.subscriptionManager
          .createRequest(
            this.calendarService.exportPlanningData({
              position: position,
              reverseOrderName: localStorage.getItem('reverseOrderName') === 'true' ? true : false,
              startDate: this.formatDateToYYYYMMDD(startDate),
              endDate: this.formatDateToYYYYMMDD(endDate),
              hospitalId,
              populationId: populationId === 'none' ? undefined : populationId,
            }),
            'exportPlanningData',
            this.instanceId
          )
          .subscribe({
            next: (res: any) => {
              const nightData = res?.nightData ?? [];
              const dayData = res?.dayData ?? [];
              const data = this.concatenateDayNightData(dayData, nightData);
              const formatDateCompact = (date: Date): string => {
                const year = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');
                return `${year}${month}${day}`;
              };
              const normalizeFileName = (text: string): string => {
                if (!text) {
                  return 'liste';
                }

                return text
                  .toLowerCase()
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .replace(/[\/\\]/g, '')
                  .trim()
                  .replace(/\s+/g, '_')
                  .replace(/-+/g, '_')
                  .replace(/_+/g, '_')
                  .replace(/^_+|_+$/g, '');
              };

              const startDateStr = formatDateCompact(startDate);
              const endDateStr = formatDateCompact(endDate);
              const pageTitle = this.actifPageList;
              const normalizedTitle = normalizeFileName(pageTitle);

              const fileName2 = `staff_list_${normalizedTitle}_${startDateStr}_${endDateStr}`;
              const fileName1 = `staff_list_${normalizedTitle}_${startDateStr}_${endDateStr}_total`;
              this.exportService
                .saveExcel2(data, fileName2, false)
                .catch((error) => this.errorService.handleError(error));
              this.exportService.saveExcel1(dayData, nightData, ['NIGHT', 'DAY'], fileName1);
            },
            error: (error: any) => this.errorService.handleError(error),
          });
      },
      error: (error: any) => this.errorService.handleError(error),
    });
  }

  private formatDateToYYYYMMDD(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  concatenateDayNightData(dayData: any[], nightData: any[]): any[] {
    const combinedData: { [key: string]: any } = {};

    dayData.forEach((profile: any) => {
      const fullname = profile.fullname;
      if (!combinedData[fullname]) {
        combinedData[fullname] = {
          fullname: fullname,
          dates: [],
        };
      }

      if (profile.dates && Array.isArray(profile.dates)) {
        combinedData[fullname].dates.push(...profile.dates);
      }
    });

    nightData.forEach((profile: any) => {
      const fullname = profile.fullname;
      if (!combinedData[fullname]) {
        combinedData[fullname] = {
          fullname: fullname,
          dates: [],
        };
      }

      if (profile.dates && Array.isArray(profile.dates)) {
        combinedData[fullname].dates.push(...profile.dates);
      }
    });

    return Object.values(combinedData).map((profile: any) => ({
      ...profile,
      dates: profile.dates.sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime()),
    }));
  }

  changeCampaignPos() {
    this.hrsuiteService.campaignPosition.next(this.actifPageCampaign);
  }

  changeListePos() {
    this.hrsuiteService.listePositions.next(this.actifPageList);
  }

  changeDemandePos() {
    this.hrsuiteService.demandePositions.next(this.actifPageDemande);
  }

  saveAnesthNeeds() {
    if (this.isChangeAnesthNeeds) {
      posthog.capture('Save_Needs_Garde_Changes', { page_source: 'Needs_Garde' });
      this.hrsuiteService.saveAnesthNeedsSubject.next(true);
    }
  }

  refreshAnesthNeeds() {
    if (this.isChangeAnesthNeeds) {
      posthog.capture('Cancel_Needs_Garde_Changes', { page_source: 'Needs_Garde' });
      this.hrsuiteService.refreshAnesthNeedsSubject.next(true);
    }
  }

  triggerRequestCalendarsFromHospital() {
    posthog.capture('Open_Request_Calendars_From_Hospital_Form', { page_source: 'Profile_List' });
    this.hrsuiteService.requestCalendarsFromHospitalSubject.next();
  }

  triggeradjustPlanning() {
    this.hrsuiteService.adjustPlanningSubject.next();
  }

  getReasons() {
    return new Promise<void>((resolve: (value?: void | PromiseLike<void>) => void, reject: (reason?: any) => void) => {
      this.subscriptionManager
        .createRequest(this.reasonService.getReason(this.isNight), 'getReason', this.instanceId)
        .subscribe({
          next: (res: any) => {
            const tmp: any[] = [];
            res.forEach((item: { reasons: Reason[] }) => {
              item.reasons = item.reasons.filter((r: Reason) => !r.disabled);
            });
            this.reasons = res;
            for (let index = 0; index < res.length; index++) {
              const reasons = res[index].reasons;
              const extraIndex = reasons.findIndex((reason: Reason) => reason.title == 'Extraclinique');
              if (extraIndex != -1) {
                reasons.splice(extraIndex, 1);
              }
              tmp.push(...reasons);
            }
            this.allReasons = tmp.filter((reason: Reason, pos: number) => {
              return tmp.findIndex((reas: Reason) => reas.title == reason.title) == pos;
            });
            return resolve();
          },
          error: (error: any) => {
            this.errorService.handleError(error);
            reject();
          },
        });
    });
  }

  getReasonsMaps() {
    return new Promise<void>((resolve: (value?: void | PromiseLike<void>) => void, reject: (reason?: any) => void) => {
      this.subscriptionManager
        .createRequest(this.reasonMapService.getSuggestedReasonsMaps(true), 'getSuggestedReasonsMaps', this.instanceId)
        .subscribe({
          next: (res: any) => {
            this.reasonsMaps = res;
            resolve();
          },
          error: (error: any) => {
            this.errorService.handleError(error);
            reject();
          },
        });
    });
  }

  ngOnDestroy(): void {
    this.hrsuiteService.toggleNightSubject.next(false);
  }
}
